import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ApplyVolComponent } from '../../../components/apply-vol/apply-vol';
import { FeatureSkillsComponent } from '../../../components/feature-skills/feature-skills';
import { FooterComponent } from '../../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../../components/header-desktop/header-desktop';
import { SlugifyPipe } from '../../../components/slugify.pipe';
import { TypePipe } from '../../../components/type.pipe';
import { YoutubePlayerComponent } from '../../../components/youtube-player/youtube-player';
import { AuthService } from '../../../core/auth.service';
import { VolService } from '../../../core/vol.service';
import { globals } from '../../../../environments/globals';
import { environment } from '../../../../environments/environment';

@Component({
    imports: [CommonModule, ApplyVolComponent, FeatureSkillsComponent, FooterComponent, FooterDesktopComponent, HeaderComponent, HeaderDesktopComponent, SlugifyPipe, TypePipe, YoutubePlayerComponent],
    selector: 'app-detail',
    styleUrls: ['./detail.page.scss'],
    templateUrl: './detail.page.html'
})
export class DetailPage implements OnInit {
  bucketURL: string = environment.firebase.bucketURL;
  slug: any;
  vol: any;
  directory: any = globals.directory;
  directory_data: any;
  isApply: boolean = false;
  text: any;
  constructor(
    @Inject(DOCUMENT) private doc: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    public auth: AuthService, 
    private metaService: Meta,
    private route: ActivatedRoute,
    private titleService: Title,
    private vs: VolService
  ) {}

  ngOnInit() {
    this.slug = this.route.snapshot.paramMap.get('slug');
    this.vs.volDetails(this.slug).subscribe(data => {
      this.vol = data[0];
      if(this.vol.country) {
        this.directory_data = this.directory[this.vol.country];
        this.titleService.setTitle(this.vol.title + ' | ' + (this.vol.location=='remote' ? 'Remote' : 'Onsite ' + this.vol.suburb + ' ' + this.vol.city) + ' ' + this.directory_data.name);
        this.metaService.updateTag(
          { name: 'description', property: 'og:description', content: this.vol.title + ' | ' + (this.vol.location=='remote' ? 'Remote - Work from Anywhere' : 'Onsite ' + this.vol.suburb + ' ' + this.vol.city) + ' ' + this.directory_data.name + ' | ' + this.vol.overview }
        )
        this.createStructuredData();
      }
      if(this.vol.video) {
        this.videoStructuredData();
      }
    })
  }

  createStructuredData() {
    if (isPlatformBrowser(this.platformId)) {
      const script = <HTMLScriptElement> this.doc.head.querySelector("script[type='application/ld+json']")
      || this.doc.head.appendChild(this.doc.createElement("script"));
      if(this.vol) {
        this.text = {
          "@context": "https://schema.org",
          "@type" : "JobPosting",
          "title" : this.vol.title,
          "industry" : this.vol.grouping,
          "description" : this.vol.description,
          "datePosted" : this.vol.posted,
          "validThrough" : new Date(this.vol.unpublish),
          "employmentType" : "VOLUNTEER", // FULL_TIME, PART_TIME, CONTRACTOR, TEMPORARY, INTERN, VOLUNTEER, PER_DIEM, OTHER 
          "hiringOrganization" : {
            "@type" : "Organization",
            "name" : this.vol.company,
          },
          "baseSalary": {
            "@type": "MonetaryAmount",
            "value": {
              "@type": "QuantitativeValue",
              "value": 0,
              "unitText": "HOUR" // HOUR, DAY, WEEK, MONTH, YEAR
            }
          }
        }
        if(this.vol.location == 'onsite') {
          this.text.jobLocation = {
            "@type": "Place",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": this.vol.suburb,
              "addressLocality": this.vol.city,
              "addressRegion": this.vol.region,
              "addressCountry": this.vol.country
            }
          }
        } else {
          this.text.jobLocationType = "TELECOMMUTE";
          this.text.applicantLocationRequirements = {
            "@type": "Country",
            "name": "GLOBAL"
          };
        }
        if(this.vol.contact && this.vol.contact !== '') {
          this.text.applicationContact = this.vol.contact;
        }
        if(this.vol.logo && this.vol.logo !== '') {
          this.text.hiringOrganization.logo = this.bucketURL + this.vol.logo + '?alt=media';
        }
      }

      script.type = "application/ld+json";
      script.text = JSON.stringify(this.text);
    }
  }

  videoStructuredData() {
    if (isPlatformBrowser(this.platformId)) {
      const script = <HTMLScriptElement> this.doc.body.querySelector("script[type='application/ld+json']")
      || this.doc.body.appendChild(this.doc.createElement("script"));
      if(this.vol) {
        this.text = {
          "@context": "https://schema.org",
          "@type" : "VideoObject",
          "name" : this.vol.title,
          "description" : this.vol.overview,
          "uploadDate" : this.vol.posted,
          "embedUrl" : this.vol.video,
        }
      }
      if(this.vol.video && this.vol.video !== '') {
        this.text.thumbnailUrl = ["https://i.ytimg.com/vi_webp/" + this.vol.video.slice(-11) + "/maxresdefault.webp"];
      }
      script.type = "application/ld+json";
      script.text = JSON.stringify(this.text);
    }
  }
}